import { render, staticRenderFns } from "./Syncs.vue?vue&type=template&id=b42ec7ac"
import script from "./Syncs.vue?vue&type=script&lang=js"
export * from "./Syncs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports